import { render, staticRenderFns } from "./DataViewSidebarAviz.vue?vue&type=template&id=281f3d75&scoped=true"
import script from "./DataViewSidebarAviz.vue?vue&type=script&lang=js"
export * from "./DataViewSidebarAviz.vue?vue&type=script&lang=js"
import style0 from "./DataViewSidebarAviz.vue?vue&type=style&index=0&id=281f3d75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f3d75",
  null
  
)

export default component.exports